<template>
  <v-list-tile v-if="!isEditing" avatar ripple>
    <v-list-tile-avatar>
      <font-awesome-icon :icon="['fal', 'home']"></font-awesome-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-sub-title class="caption">{{ printZip }}&nbsp;{{ printKana }}</v-list-tile-sub-title>
      <v-list-tile-title>{{ printAddress }}</v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <v-menu offset-y>
        <v-btn flat icon slot="activator" class="blue--text text--darken-2" :loading="isThisLoading"><v-icon>more_vert</v-icon></v-btn>
        <v-list>
          <v-list-tile @click="edit">
            <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'pencil']"/></v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>編集する</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="remove">
            <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'trash-alt']"/></v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>削除する</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-list-tile-action>
    <UtilConfirmModal ref="confirm"></UtilConfirmModal>
  </v-list-tile>
  <v-container v-else>
    <v-layout wrap class="pb-4">
      <v-flex xs12 class="px-3">
        <v-text-field required
          v-model="form.zip"
          label="郵便番号"
          :rules="rules.zip"
          mask="###-####"
          append-icon="search"
          @click:append="search"
          @keypress.enter.prevent="search"></v-text-field>
      </v-flex>
      <v-flex xs12 class="px-3">
        <v-select
          v-model="form.pref"
          label="都道府県"
          :items="getPrefItems"></v-select>
      </v-flex>
      <v-flex xs12 class="px-3">
        <v-text-field ref="city"
          v-model="form.city"
          label="市町村区"></v-text-field>
      </v-flex>
      <v-flex xs12 class="px-3">
        <v-text-field ref="number"
          v-model="form.number"
          label="番地・建物"></v-text-field>
      </v-flex>
      <v-flex xs12 class="px-3">
        <v-text-field
          v-model="form.kana"
          label="ふりがな"></v-text-field>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import UtilConfirmModal from '@/components/modals/confirm'
export default {
  name: 'clientAboutGuardiansAddress',
  components: {
    UtilConfirmModal
  },
  props: [
    'gid',
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        type: 'home',
        status: {
          loading: false
        }
      },
      form: {
        id: '',
        zip: '',
        pref: '',
        city: '',
        number: '',
        kana: ''
      },
      rules: {
        zip: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.data.zip &&
        this.$props.data.pref != null &&
        this.$props.data.city != null &&
        this.$props.data.number != null &&
        this.$props.data.kana != null
      ) {
        this.$set(this, 'form', {
          valid: true,
          id: this.$props.data.id,
          zip: this.$props.data.zip,
          pref: this.$props.data.pref,
          city: this.$props.data.city,
          number: this.$props.data.number,
          kana: this.$props.data.kana
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          id: (this.$props.data && this.$props.data.id) ? this.$props.data.id : '',
          type: this.config.type
        }
      })
    },
    search: function () {
      if (this.form.zip.length === 7) {
        this.$set(this.config.status, 'searching', true)
        this.axios.get(this.$url.zip + this.form.zip).then(res => {
          console.log(res)
          if (res.data.code === 200) {
            let data = res.data.data
            this.$set(this.form, 'pref', data.pref)
            this.$set(this.form, 'city', data.city)
            this.$set(this.form, 'number', data.town)
            this.$set(this.config.status, 'searching', false)
            this.$refs.number.focus()
            this.$store.dispatch('notifier/addSMessage', {
              title: '住所が見つかりました',
              message: data.pref + data.city + data.town
            })
          } else {
            this.$store.dispatch('notifier/addAlert', {
              title: '住所検索失敗',
              message: this.$error.zip.search.unmatch
            })
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },
    remove: function () {
      if (
        this.$props.data &&
        this.$props.data.id &&
        this.$props.gid
      ) {
        this.$refs.confirm.open({
          title: '住所の削除',
          message: (
            this.$props.data &&
            this.$props.data.pref &&
            this.$props.data.city &&
            this.$props.data.number
          ) ? [
              'この住所を削除してもよろしいですか？',
              '<br/>',
              this.$props.data.pref,
              this.$props.data.city,
              this.$props.data.number
            ].join('') : '',
          callback: () => {
            this.$set(this.config.status, 'loading', true)
            this.axios.post(this.$url.api + 'user/about/delete/address', {
              id: this.$props.data.id,
              cid: this.$props.gid
            }, {
              headers: {
                'user-token': this.$localStorage.get('jwt')
              }
            }).then(res => {
              console.log(res)
              if (res.data && res.data.success) {
                this.$emit('emit', {
                  action: 'removeAddress',
                  data: res.data.data.id ? res.data.data.id : ''
                })
              }
            })
          }
        })
      }
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        (this.$props.status.editing === 'all' || this.$props.status.editing === this.$props.data.id)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.editing === this.$props.data.id
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.loading === this.$props.data.id
      )
    },
    printZip () {
      return (
        this.$props.data &&
        this.$props.data.zip
      ) ? ('〒' + this.$props.data.zip.substr(0, 3) + '-' + this.$props.data.zip.substr(3)) : ''
    },
    printKana () {
      return (
        this.$props.data &&
        this.$props.data.kana
      ) ? this.$props.data.kana : ''
    },
    printAddress () {
      return (
        this.$props.data &&
        this.$props.data.pref &&
        this.$props.data.city &&
        this.$props.data.number
      ) ? [
          this.$props.data.pref,
          this.$props.data.city,
          this.$props.data.number
        ].join('') : ''
    },
    getPrefItems () {
      return Object.keys(this.$meta.prefs)
    }
  }
}
</script>
